import React from 'react';

import PrivacyPolicyModule from '../../modules/PrivacyPolicyModule';

const PrivacyPolicy = () => <PrivacyPolicyModule />;

export default PrivacyPolicy;
